import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import SettingsPage from '../../views/SettingsPage/';

class AcademicUpdate extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			alertClass :'',
			id : '',
			startyear : '',
			startmonth : '',
			endyear : '',
			endmonth : '',
			yearstatus : '',
			posts : [],
			_redirect : false
		}
		this.handleInputChange = this.handleInputChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.getdetails = this.getdetails.bind(this);
		this.back = this.back.bind(this);
	}
	
	/** redirect to Academic **/
	back(e){
		
		this.setState({_redirect :true});
	}
	
	/** set value **/
	handleInputChange(e){
		
		/* const target = e.target;
		// const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		const value = target.value;

		this.setState({
		  [name]: value
		}); */
	
		this.setState({[e.target.name]:e.target.value});
		// console.log(this.state);
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.startyear && this.state.startmonth && this.state.endyear && this.state.endmonth && this.state.yearstatus){
			console.log(this.state);
			PostData('academic/updateacyear',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Academic Year Updated Successfullly',
						alertClass:'alert alert-success'
					});	
					document.getElementById("subform").reset();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdetails();
	}
	
	/** get Academic Details **/
	getdetails(){
	  
		GetData('academic/getacyearbyid/'+this.props.match.params.id).then((result) => {
			let res = result;
			if(res){
				this.setState({
					startyear : res[0]['startyear'],
				startmonth : res[0]['startmonth'],
				endyear : res[0]['endyear'],
				endmonth : res[0]['endmonth'],
				yearstatus: res[0]['yearstatus']
				});
				
			}
			
		});
		
	}
	
	
  render() {
	
	/** match id to update **/
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/settings/academic' />);
	}
	
	/** get year only select box **/
	const currentYear = new Date().getFullYear();
	const fromMonth = new Date(currentYear - 1, 0);
	const toMonth = new Date(currentYear + 10, 11);
	
	const years = [];
	  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
		years.push(i);
	  }
	
	/** set month in select box **/
	  this.month = [
		{value : '', name: 'Select Month'},
		{value : 'January', name: 'January'},
		{value : 'February', name: 'February'},
		{value : 'March', name: 'March'},
		{value : 'April', name: 'April'},
		{value : 'May', name: 'May'},
		{value : 'June', name: 'June'},
		{value : 'July', name: 'July'},
		{value : 'August', name: 'August'},
		{value : 'September', name: 'September'},
		{value : 'October', name: 'October'},
		{value : 'November', name: 'November'},
		{value : 'December', name: 'December'}
	];
	
	/** set status select box **/
	this.acyearstatus = [
		{value : '', name : 'Select'},
		{value : 'Active', name : 'Active'},
		{value : 'Deactive', name : 'Deactive'}
	];
	
    return (
		<div>
		  <SettingsPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="6">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card>
					  <form action="" method="post" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Edit Academic Details</strong>
							<span className="pull-right">
								<Button outline color="primary" onClick={this.back}>Back</Button>
							</span>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Start Year</Label>
								  <select name="startyear" className="form-control" value={this.state.startyear} onChange={this.handleInputChange} required disabled>
									{years.map(year => (
									  <option key={year} value={year}>
										{year}
									  </option>
									))}
								 </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Start Month</Label>
								  <select name="startmonth" className="form-control" value={this.state.startmonth} onChange={this.handleInputChange} required>
									{this.month.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								 </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">End Year</Label>
								  <select name="endyear" className="form-control" value={this.state.endyear} onChange={this.handleInputChange} required disabled>
									{years.map(year => (
									  <option key={year} value={year}>
										{year}
									  </option>
									))}	
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">End Month</Label>
								  <select name="endmonth" className="form-control" value={this.state.endmonth} onChange={this.handleInputChange} required>
									{this.month.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Active / Deactive</Label>
								  <select name="yearstatus" className="form-control" value={this.state.yearstatus} onChange={this.handleInputChange} required>
									{this.acyearstatus.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								  </select>
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="success"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default AcademicUpdate;



// WEBPACK FOOTER //
// ./src/settings/AcademicUpdate/AcademicUpdate.js